<!-- 利用開始日の選択欄 -->
<template>
  <div class="field">
    <!-- 利用開始日ラベル -->
    <label>{{ $t("common.startDateLabel") }}</label>

    <!-- ユーザーが一度でも利用開始日欄をクリックしたことを判別するためにinputが2個並ぶ -->
    <!-- setStartDateが発火すると、クリックしたことを管理するフラグ(date_flag)がtrueになって上のinputは消える -->
    <input
      v-if="!date_flag"
      class="fake"
      placeholder="利用開始日を選択してください"
      @click="setStartDate()"
    />

    <!-- 日時選択のinput -->
    <input
      id="book-booking-date"
      ref="datePicker"
      v-model="startDateOfUse"
      type="date"
      name="date"
      class="form-control datepicker"
      required="required"
      :style="[
        !date_flag ? { opacity: '0', position: 'absolute' } : { opacity: '1' },
      ]"
      @input="onSelectedDate(startDateOfUse)"
    />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import moment from "@/services/moment";

export default {
  name: "MbPurchaseStartedatSelect",
  props: {
    onSelectedDate: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    // TODO: v-modelを使ってstartDateOfUseの使用を廃止できないか確認する
    const startDateOfUse = ref(null);
    const date_flag = ref(false);
    const datePicker = ref(null);

    onMounted(() => {
      const _masterBook = store.getters["ticketing/masterBook"];
      const _storeStartDateOfUse =
        store.getters["input/ticketing/storeStartDateOfUse"];
      setInitStartDateOfUse(_masterBook, _storeStartDateOfUse);
    });

    const setInitStartDateOfUse = (masterBook, storeStartDateOfUse) => {
      // 開始日
      var start = getStartDate(masterBook.purchase_started_at);
      // storeに選択中の日付がなければ開始日を設定
      startDateOfUse.value =
        storeStartDateOfUse === null
          ? moment(start).format("YYYY-MM-DD")
          : storeStartDateOfUse;
    };

    const getStartDate = (purchase_started_at) => {
      var purchase_start = moment(new Date(purchase_started_at));
      var current_time = moment(new Date());

      return current_time.isBefore(purchase_start)
        ? purchase_start
        : current_time;
    };

    const setStartDate = () => {
      date_flag.value = true;
      datePicker.value.focus();
      props.onSelectedDate(startDateOfUse.value);
    };

    return {
      startDateOfUse,
      date_flag,
      setStartDate,
      datePicker,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}

label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

.fake {
  -webkit-appearance: none;
  width: calc(100% - 100px);
  height: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  padding: 12px 0px 12px 100px;
  font-size: 16px;
  font-weight: bold;
  background: white;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
  position: static;
}

.fake::placeholder {
  color: black;
}

input[type="date"] {
  -webkit-appearance: none;
  width: calc(100% - 150px - 12px);
  height: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  padding: 12px 10px 12px 150px;
  font-size: 16px;
  font-weight: bold;
  background: white;
  color: #000000;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
}
</style>
